// Angular
import { registerLocaleData } from '@angular/common';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import LOCALE_PT from '@angular/common/locales/pt';
import { LOCALE_ID, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouterModule } from '@angular/router';
import { BnNgIdleService } from 'bn-ng-idle';

// Português Brasileiro
registerLocaleData(LOCALE_PT, 'pt');

// Angular2TextMask
import { TextMaskModule } from 'angular2-text-mask';

// NG Bootstrap
import {NgbModalModule, NgbTooltipModule, NgbDropdownModule, NgbTypeaheadModule, NgbNavModule} from '@ng-bootstrap/ng-bootstrap';

// Roteamento
import { AppRoutingModule } from '@app/app-routing.module';

// Shared
import { SharedModule } from '@app/shared/shared.module';

// Components
import { AlteracaoEmailComponent } from '@app/components/alteracao-email/alteracao-email.component';
import { AppComponent } from '@app/app.component';
import { FooterComponent } from '@app/components/footer/footer.component';
import { HeaderComponent } from '@app/components/header/header.component';
import { PerguntasSegurancaComponent } from '@app/components/perguntas-seguranca/perguntas-seguranca.component';
import { TituloComponent } from '@app/components/titulo/titulo.component';
import { UploadArquivoComponent } from '@app/components/upload-arquivo/upload-arquivo.component';

// Pages
import { AlteracaoSenhaPage } from '@app/pages/alteracao-senha/alteracao-senha.page';
import { CadastroUsuarioPage } from '@app/pages/cadastro-usuario/cadastro-usuario.page';
import { CurriculoPage } from '@app/pages/curriculo/curriculo.page';
import { InscricaoPage } from '@app/pages/inscricao/inscricao.page';
import { LoginPage } from '@app/pages/login/login.page';
import { PaginaNaoEncontradaPage } from '@app/pages/pagina-nao-encontrada/pagina-nao-encontrada.page';
import { VagaDetalhesPage } from '@app/pages/vaga-detalhes/vaga-detalhes.page';
import { VagaListaPage } from '@app/pages/vaga-lista/vaga-lista.page';
import { RecuperacaoSenhaPage } from '@app/pages/recuperacao-senha/recuperacao-senha.page';
import { SubstituicaoEmailPage } from '@app/pages/substituicao-email/substituicao-email-page';
import { VersionCheckService } from './shared/services/version-check-service.service';
import { TermoLgpdComponent } from './pages/termo-lgpd/termo-lgpd.component';
import { VagaParticiparEntrevistaPage } from './pages/vaga-participar-entrevista/vaga-participar-entrevista.page';
import { CountdownModule } from 'ngx-countdown';
import { ProvaOnlineComponent } from './components/prova-online/prova-online.component';
import { OrientacoesProvaOnlineComponent } from './components/prova-online/orientacoes-prova-online/orientacoes-prova-online.component';
import { EditarDadosPage } from '@app/pages/editar-dados/editar-dados.page';
import { FazerRedacaoPage } from './pages/fazer-redacao/fazer-redacao.page';
import { WebcamModule } from 'ngx-webcam';
import { AvisoPrivacidadePage } from '@app/pages/aviso-privacidade/aviso-privacidade.page';



@NgModule({
  declarations: [
    // Components
    AlteracaoEmailComponent,
    AppComponent,
    FooterComponent,
    HeaderComponent,
    PerguntasSegurancaComponent,
    TituloComponent,
    UploadArquivoComponent,
    // Pages
    AlteracaoSenhaPage,
    CadastroUsuarioPage,
    CurriculoPage,
    InscricaoPage,
    LoginPage,
    PaginaNaoEncontradaPage,
    RecuperacaoSenhaPage,
    SubstituicaoEmailPage,
    VagaDetalhesPage,
    VagaListaPage,
    TermoLgpdComponent,
    VagaParticiparEntrevistaPage,
    ProvaOnlineComponent,
    OrientacoesProvaOnlineComponent,
    EditarDadosPage,
    FazerRedacaoPage,
    AvisoPrivacidadePage
  ],
  entryComponents: [
    // Components
    UploadArquivoComponent
  ],
    imports: [
        // Angular
        BrowserAnimationsModule,
        BrowserModule,
        FormsModule,
        HttpClientModule,
        ReactiveFormsModule,
        RouterModule,
        // Angular2TextMask
        TextMaskModule,
        // NG Bootstrap
        NgbDropdownModule,
        NgbModalModule,
        NgbTooltipModule,
        NgbTypeaheadModule,
        // Roteamento
        AppRoutingModule,
        // Shared
        SharedModule,
        // CountdownComponent
        CountdownModule,
        WebcamModule,
        NgbNavModule,
    ],
  providers: [
    // Português Brasileiro
    VersionCheckService,
    BnNgIdleService,
    { provide: LOCALE_ID, useValue: 'pt' }
  ],
  bootstrap: [
    AppComponent
  ]
})
export class AppModule { }
